module.exports = __webpack_public_path__ + "static/media/Kuva_5_3.59998748.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_5_3.png
// module id = 1400
// module chunks = 0